(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("imagej", [], factory);
	else if(typeof exports === 'object')
		exports["imagej"] = factory();
	else
		root["imagej"] = factory();
})(window, function() {
return 